module.exports = __webpack_public_path__ + "img/25-building-a-low-carbon.7cc1f918.jpg";